<template>
  <validation-provider
    #default="{ errors }"
    :name="defaultName"
    :vid="id"
    :rules="rules"
    mode="passive"
  >
    <b-form-group :label="label" :label-for="id">
      <v-select
        :options="options"
        :name="name"
        :dir="isRTL"
        :id="id"
        v-bind="$attrs"
        v-on="$listeners"
        :class="{ 'has-error': errors.length > 0 && !$attrs.value }"
        :reduce="(x) => x.value"
      >
        <template v-for="(index, name) in $scopedSlots" v-slot:[name]="data">
          <slot :name="name" v-bind="data"></slot>
        </template>
        <template #selected-option="{ value, name_ar }">
          <div class="d-flex align-items-center">
            <img
              :src="require(`@/assets/contacts/${value}.png`)"
              width="25px"
              height="25px"
            />
            <div class="mx-1">{{ name_ar }}</div>
          </div>
        </template>
        <template #option="{ value, name_ar }">
          <div class="d-flex align-items-center">
            <img
              :src="require(`@/assets/contacts/${value}.png`)"
              width="25px"
              height="25px"
            />
            <div class="mx-1">{{ name_ar }}</div>
          </div>
        </template>
        <template #no-options> لا يوجد نتائج لعرضها </template>
        <template #spinner="{ loading }">
          <b-spinner
            small
            variant="primary"
            v-if="loading"
          ></b-spinner> </template
      ></v-select>
      <small class="text-danger" v-if="errors.length > 0 && !$attrs.value">
        {{ errors[0] }}
      </small>
    </b-form-group>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import vSelect from "vue-select";
import { BFormGroup, BAvatar } from "bootstrap-vue";
import { $themeConfig } from "@themeConfig";
import { required } from "@validations";
export default {
  components: {
    ValidationProvider,
    vSelect,
    BAvatar,
    BFormGroup,
  },
  props: {
    id: {
      type: String,
      default: () => "select",
    },
    name: {
      type: String,
    },
    rules: {
      type: String,
      default: () => "",
    },
    label: {
      type: String,
      default: () => "",
    },
  },
  data() {
    return {
      required,
      options: [
        {
          name_ar: "فيسبوك",
          icon: "FacebookIcon",
          value: "facebook_contact",
        },
        {
          name_ar: "واتساب",
          icon: "",
          value: "whatsapp_contact",
        },
        {
          name_ar: "البريد الالكتروني",
          icon: "MailIcon",
          value: "mail_contact",
        },
        {
          name_ar: "سكايب",
          icon: "",
          value: "skype_contact",
        },
        {
          name_ar: "إنستغرام",
          icon: "InstagramIcon",
          value: "instagram_contact",
        },
        {
          name_ar: "رقم الهاتف",
          icon: "PhoneIcon",
          value: "phone_contact",
        },
        {
          name_ar: "فاكس",
          icon: "",
          value: "Fax_contact",
        },
      ],
    };
  },
  computed: {
    isRTL() {
      return $themeConfig.layout.isRTL ? "rtl" : "ltr";
    },

    defaultName() {
      return this.name || this.label;
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.has-error {
  .vs__dropdown-toggle {
    border: 1px solid #ea5455 !important;
  }
}
</style>
